$(document).ready(function() {
  $('.logo-bar').slick({
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    ]
  });

  $(document).on('click', '[data-behavior="tab-header"]', function(e) {
    e.preventDefault();
    if($(this).hasClass('active')) {
      return;
    }
    let tabContainer = $(this).closest('.product-description-tabs');
    let targetBody = $(this).attr('data-target');
    tabContainer.find('.pdt-header--item, .pdt-body--header').removeClass('active');
    $(this).closest('.pdt-header--item, .pdt-body--header').addClass('active');

    tabContainer.find('.pdt-body--item').slideUp();
    $(targetBody).slideDown();
  });

  $(document).on('click', '[data-behavior="wtb-tabs-header"]', function(e) {
    e.preventDefault();
    if($(this).hasClass('active')) {
      return;
    }
    let tabContainer = $(this).closest('.wtb-tabs-container');
    let targetBody = $(this).attr('data-target');
    tabContainer.find('.wtb-tabs-body--item, .wtb-tabs-header--item').removeClass('active');
    $(this).addClass('active').closest('.wtb-tabs-body--item').addClass('active');

    tabContainer.find('.wtb-tabs-body--item').slideUp();
    $(targetBody).slideDown();
  });
  
  document.addEventListener('tomitProductLoaded', function(e) {
    renderProductInventoryTableTemplate(tomitProductInventoryInfo.activeProduct);
  });

  $(document).on('click', '.product-downlaods--view-more', function() {
    $(this).closest('.product-downloads-container').toggleClass('has-overflow');
    if($(this).closest('.product-downloads-container').hasClass('has-overflow')) {
      $(this).text('View More');
    } else {
      $(this).text('View Less');
    }
  });

  // add product slick setting
  var generalSliderSettings = {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='10' height='19' viewBox='0 0 18.562 34.295'><title>Previous Slide</title><g transform='translate(1.414 0.707)'><path d='M0,0,16.44,16.44,32.881,0' transform='translate(16.44) rotate(90)' fill='none' stroke='currentColor' stroke-width='2'/></g></svg></button>",
    nextArrow: "<button type='button' class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='10' height='19' viewBox='0 0 18.562 34.295'><title>Next Slide</title><g transform='translate(0.707 0.707)'><path d='M0,0,16.44,16.44,32.881,0' transform='translate(0 32.88) rotate(-90)' fill='none' stroke='currentColor' stroke-width='2'/></g></svg></button>"
  };
  if ($('.product-features__slider').length > 0) {
    $('.product-features__slider').slick(generalSliderSettings);
  }

  if ($('.product-optional-accessories .cf-widget-optional-accessories').length > 0) {
    $('.product-optional-accessories .cf-widget-items-wrapper').slick({
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='10' height='19' viewBox='0 0 18.562 34.295'><title>Previous Slide</title><g transform='translate(1.414 0.707)'><path d='M0,0,16.44,16.44,32.881,0' transform='translate(16.44) rotate(90)' fill='none' stroke='currentColor' stroke-width='2'/></g></svg></button>",
      nextArrow: "<button type='button' class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='10' height='19' viewBox='0 0 18.562 34.295'><title>Next Slide</title><g transform='translate(0.707 0.707)'><path d='M0,0,16.44,16.44,32.881,0' transform='translate(0 32.88) rotate(-90)' fill='none' stroke='currentColor' stroke-width='2'/></g></svg></button>",
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 959,
          settings: {
            slidesToShow: 3,
          },
        }
      ],
    });
  }

  if ($('.product-ideals__slider').length > 0) {
    $('.product-ideals__slider').slick(generalSliderSettings);
  }

  if ($('.product-download__slider').length > 0 && window.matchMedia('(max-width: 767px)').matches) {
    $('.product-download__slider').slick(generalSliderSettings);
  }

  if ($('.product-support__slider').length > 0 && window.matchMedia('(max-width: 767px)').matches) {
    $('.product-support__slider').slick(generalSliderSettings);
  }

  if ($('.product-video__slider').length > 0) {
    const productVideoSlider = $('.product-video__slider').slick({
      ...generalSliderSettings,
      arrows: false,
      infinite: false,
      centerMode: true,
      centerPadding: '5%',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            arrows: true,
          },
        },
        {
          breakpoint: 1580,
          settings: {
            arrows: true,
            centerPadding: 'calc((100vw - 1500px + 60px) / 2)'
          }
        }
      ],
    });

    productVideoSlider.on('afterChange', function (event, slick, direction) {
      const videoSlides = $('.product-video__slider .slick-slide');

      videoSlides.each(function () {
        $(this).find('video').get(0).pause();
      })
      $(videoSlides.get(slick.currentSlide)).find('video').get(0).play();
    });
  }

  
})

function renderProductInventoryTableTemplate(activeProduct, activeProductId) {
  let productId, east, midwest, west;
  if (typeof activeProductId !== 'undefined') {
    productId = parseInt(activeProductId);
  } else if (window.product && window.product.id) {
    productId = parseInt(window.product.id);
  }
  const productInventoryTable = $('.product-inventory-table-container[data-productId="' + productId + '"]');
  
  if (activeProduct && activeProduct.variants) {
    let entry = '<table class="product-inventory-table">';
    entry += '<thead><tr>';
    entry += '<th>SKU</th>';
    entry += '<th>Description</th>';
    entry += '<th>East</th>';
    entry += '<th>Midwest</th>';
    entry += '<th>West</th>';
    entry += '<th>DNC</th>';
    entry += '</tr></thead>';
    entry += '<tbody>';
    $.each(activeProduct.variants, function(index, variant) {
      let locations = variant.inventoryItem.locations;
      let variantId = parseInt(variant.id);
      let name, dnc, variantArr, product, productTitle;
      east = 0;
      midwest = 0;
      west = 0;
      dnc = 0;
      if (window.product && window.product.variants) {
        // product page
        productTitle= $('.product-single__title').html();
        variantArr = window.product.variants.filter( variant => variantId === variant.id);
        if (variantArr.length) {
          dnc = variantArr[0].price / 100;
          dnc = new Intl.NumberFormat('us-EN', { style: 'currency', currency: 'USD' }).format(dnc);
        }
      } else if (window.products) {
        productTitle = productInventoryTable.parent().find('.boost-pfs-filter-product-item-title').html();
        // collection page
        product = window.products.filter( product => productId === product.id);
        if (product.length) {
          variantArr = product[0].variants.filter( variant => variantId === variant.id);
          if (variantArr.length) {
            dnc = variantArr[0].price;
            dnc = new Intl.NumberFormat('us-EN', { style: 'currency', currency: 'USD' }).format(dnc);
          }
        }
      }
      name = variant.title == 'Default Title' ? productTitle : variant.title;
//       $.each(locations, function(index, location) {
//         switch(location.name) {
//           case 'EAST | Bulbs.com':
//           case 'EAST | HY':
//             east += location.available;
//             break;
//           case 'MIDWEST | DTX':
//           case 'MIDWEST | CA Lighting':
//           case 'MIDWEST | FYT':
//             midwest += location.available;
//             break;
//           case 'WEST | Montclair':
//           case 'WEST | DCA':
//           case 'WEST | MING':
//             west += location.available;
//             break;
//         }
//       })
      $.each(locations, function(index, location) {
        
        switch(location.name) {
          case 'EAST | Bulbs.com':
          case 'EAST | HY':
            east = (Number(location.available) + Number(east));
            break;
          case 'MIDWEST | DTX':
          case 'MIDWEST | CA Lighting':
          case 'MIDWEST | FYT':
            midwest = (Number(location.available) + Number(midwest));
            console.log(midwest)
            break;
          case 'WEST | Montclair':
          case 'WEST | DCA':
          case 'WEST | MING':
            west = (Number(location.available) + Number(west));
            break;
        }
      })      
      entry += '<tr>';
      entry += `<td>${variant.sku}</td>`;
      entry += `<td>${name}</td>`;
      entry += `<td>${new Intl.NumberFormat('us-EN', { maximumSignificantDigits: 10 }).format(east)}</td>`;
      entry += `<td>${new Intl.NumberFormat('us-EN', { maximumSignificantDigits: 10 }).format(midwest)}</td>`;
      entry += `<td>${new Intl.NumberFormat('us-EN', { maximumSignificantDigits: 10 }).format(west)}</td>`;
      entry += `<td>${dnc}</td>`;
      entry += '</tr>';
    });
    entry += '</tbody>';
    entry += '</table>';
    productInventoryTable.html(entry);
    // productInventoryTable.css('display', 'block');
  }
}

function getProductInventoryInfo(filteredProductIds) {
  tomitProductInventoryInfo.getProductsInventoryInformation(filteredProductIds).then(function(activeProducts) {
    $.each(activeProducts, function(productId, activeProduct) {
        renderProductInventoryTableTemplate(activeProduct.product, productId);
    });
  });
}


